import { render } from "./p-multiselect.vue?vue&type=template&id=23b8c490&scoped=true"
import script from "./p-multiselect.vue?vue&type=script&lang=js"
export * from "./p-multiselect.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./p-multiselect.vue?vue&type=style&index=1&id=23b8c490&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b8c490"],['__file',"src/components/p-multiselect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23b8c490"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23b8c490', __exports__)) {
    api.reload('23b8c490', __exports__)
  }
  
  module.hot.accept("./p-multiselect.vue?vue&type=template&id=23b8c490&scoped=true", () => {
    api.rerender('23b8c490', render)
  })

}


export default __exports__